import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "services-section",
  id: "services"
}
const _hoisted_2 = { class: "services-grid" }
const _hoisted_3 = { class: "service-icon" }

import {Fence, Flower2, Hammer, Leaf, Shovel, Trees} from "lucide-vue-next";

import "@/assets/styles/service.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceView',
  setup(__props) {

const services = [
  {
    icon: Trees,
    title: "Gartenpflege",
    text: "Regelmäßige Pflege für gesunde und gepflegte Außenanlagen – vom Rasen bis zur Beetpflege."
  },
  {
    icon: Fence,
    title: "Sichtschutz & Zäune",
    text: "Moderne Sichtschutzlösungen und langlebige Zaunanlagen passend zu Ihrem Grundstück."
  },
  {
    icon: Flower2,
    title: "Pflasterarbeiten",
    text: "Terrassen, Wege und Einfahrten mit hochwertigen Materialien und sauberer Umsetzung."
  },
  {
    icon: Shovel,
    title: "Erd- & Baggerarbeiten",
    text: "Professionelle Vorbereitung für Garten- und Landschaftsprojekte jeder Größe."
  },
  {
    icon: Leaf,
    title: "Hecken & Baumschnitt",
    text: "Fachgerechter Rückschnitt für gesunde Pflanzen und ein gepflegtes Gesamtbild."
  },
  {
    icon: Hammer,
    title: "Individuelle Projekte",
    text: "Maßgeschneiderte Lösungen für private Gärten und gewerbliche Außenbereiche."
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "services-header" }, [
      _createElementVNode("span", { class: "section-badge" }, " Leistungen "),
      _createElementVNode("h2", null, " Unsere Leistungen im Überblick "),
      _createElementVNode("p", null, " Von der Planung bis zur Umsetzung begleiten wir Ihr Projekt zuverlässig und professionell. ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (service) => {
        return _createElementVNode("div", {
          class: "service-card",
          key: service.title
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(service.icon)))
          ]),
          _createElementVNode("h3", null, _toDisplayString(service.title), 1),
          _createElementVNode("p", null, _toDisplayString(service.text), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})